import React, { useEffect, useRef, useState } from "react";
import "../assets/css/animate.css";
import "../assets/css/font-awesome.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/login.css";
import "../assets/css/register.css";
import "../assets/css/custom.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, Link } from "react-router-dom";
import vehicleUp from "../assets/img/vehicleUp.png";
import motorcycle from "../assets/img/motorcycle.png";
import greatcar from "../assets/img/greatcar.png";
import noAccess from "../assets/img/noaccess.png";
import carimg from "../assets/img/vehicle-car.png";
import bikeimg from "../assets/img/vehicle-bike.png";
import visit from "../assets/img/visitor.png";
import walkin from "../assets/img/walkin.png";
import visitorIn from "../assets/img/visitorIn.png";
import { Pie, Bar, Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import Menus from "./menus";
import { commonAPI } from "../services/CommonAPIService"
import { ErrorSource } from '../common/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GateIcon from '../assets/img/config-gate.png'
import footfall from  '../assets/img/footprints.png';
import hiking from  '../assets/img/hiking.png';
import hiking2 from  '../assets/img/hiking2.png';
import veh from  '../assets/img/veh.png';
import veh2 from  '../assets/img/veh2.png';
import smallcar from  '../assets/img/smallcar.png';
import NoInternet from  '../assets/img/no-signal.png';
 
import footfall2 from '../assets/img/footfall2.png'
import vst from  '../assets/img/bk.png';
import vst2 from  '../assets/img/smallbk.png';
import { DateRangePicker } from 'rsuite';
import { Offline, Online } from "react-detect-offline";
import Table from 'react-bootstrap/Table';
Chart.register(...registerables);

function Dashboard() {
  const history = useNavigate();
  const [Loading, setLoading] = useState(true);
  const [DashBoardAPIData, setDashBoardAPIData] = useState("");
  const [DashBoardAPIDataLast, setDashBoardAPIDataLast] = useState("");
  const [UserData, setUserData] = useState("");
  const [MoreThanHour, setMoreThanHour] = useState("");
  const [SmsConsumedCount, setSmsConsumedCount] = useState([]);
  const [SmsConsumedCountDate, setSmsConsumedCountDate] = useState([]);
  const [EmailConsumedCountDate, setEmailConsumedCountDate] = useState([]);
  const [NotificationConsumedCountDate, setNotificationConsumedCountDate] = useState([]);
  const [showAccess,setShowAccess] = useState(false)
  const [ApiHitTime,setApiHitTime] = useState("")
  const [VisitorDataList,setVisitorDataList] = useState("")
  
  // console.log("internet", type)
  // const [startDay,startOfDay] = useState()
  // const [endDay,endOfDay] = useState()
  const [SelectDay,setSelectDay] = useState("Today")
  console.log("SelectDay", SelectDay)
  

  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    const myUserData = JSON.parse(storedUsername);
    console.log("useEffect Local storage name", storedUsername)
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator"){
        setShowAccess(false)
        return
      }
      else{
        history('/Dashboard');
        console.log("useEffect Local storage Yes")
        setShowAccess(true)
        return
      }
      
    }
    else if (!storedUsername) {
      history('/');
      console.log("useEffect Local storage No")
    }
  }, [history]);

  function formatDateString(dateString) {
    console.log("date string", dateString)

    // Split the date string to extract date parts
    let [datePart, rest] = dateString.split('T');
    let [year, month, day] = datePart.split('-');

    // Create a date object
    let date = new Date(`${year}-${month}-${day}`);

    // Define an array of month names
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];

    // Get the day of the month
    let dayOfMonth = date.getDate();

    // Get the month name
    let monthName = monthNames[date.getMonth()];

    // Add appropriate ordinal suffix to the day
    let ordinal;
    if (dayOfMonth > 3 && dayOfMonth < 21) ordinal = 'th';
    else {
      switch (dayOfMonth % 10) {
        case 1: ordinal = 'st'; break;
        case 2: ordinal = 'nd'; break;
        case 3: ordinal = 'rd'; break;
        default: ordinal = 'th'; break;
      }
    }

    // Format the date string
    return `${dayOfMonth}${ordinal} ${monthName}`;
  }

  // const convertISTTime = (date) => {
  //   if(date != null || date != "" || date != undefined ){
  //       const [datePart, TimePart] = date.split(" ");
  //       const [mm, dd, yyyy ] = datePart.split("-");
  //       // const [hh, mn, ss] = TimePart.split('T')
  //       const formatedTime = `${dd}-${mm}-${yyyy}`;
  //       return formatedTime;
  //   }else{
  //       console.warn("input date string may be null, empty string or undefined");
  //   }
  // }

  useEffect(() => {
    // if (navigator.onLine) {
    GetAppSetting();
    // }
  }, [])

  // useEffect(() => {
  //   const auth = localStorage.getItem("userData");
  //   const myUserData = JSON.parse(auth);
  //   if(myUserData?.loginMessage == 1){
  //     toast.success("Login Successfully");
  //     setTimeout(GetLoginMessage, 2000);
      
  //   }
  // }, [])

  // const GetLoginMessage = async () => {
  //   const auth = localStorage.getItem("userData");
  //   const myUserData = JSON.parse(auth);
  //   const dataToUpdate = {
  //     ...myUserData,
  //     loginMessage: 2,
  //   };
  //   localStorage.setItem("userData", JSON.stringify(dataToUpdate));
  // }

  // useEffect(()=>{
  //   const auth = localStorage.getItem("userData");
  //   const myUserData = JSON.parse(auth);
  //   console.log(myUserData,"USERDATA")
  //   console.log(myUserData?.roleName != "Society Admin" || myUserData?.roleName != "Support Admin" || myUserData?.roleName != "Super Admin","DATATA")
  //   if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin"){
  //     setShowAccess(false)
  //     return
  //   }
  //   else{
  //     history('/Dashboard');
  //     setShowAccess(true)
  //     return
  //   }
  // },[])

  // const Ranges = [
  //   {
  //     label: 'Today',
  //     value: [startOfDay(new Date()), endOfDay(new Date())]
  //   },
  //   {
  //     label: 'Yesterday',
  //     value: [startOfDay(addDays(new Date(), -1)), endOfDay(addDays(new Date(), -1))]
  //   },
  //   {
  //     label: 'Day before yesterday',
  //     value: [startOfDay(addDays(new Date(), -2)), endOfDay(addDays(new Date(), -2))]
  //   }
  // ];

  const GetAppSetting = async () => {
    setLoading(true)
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    setUserData(myUserData)
    try {
      const endPointVariableKey = {
        buildingId: myUserData?.buildingId

      }
      let response = await commonAPI("AppSettings", undefined, endPointVariableKey)
      if (response?.success == true) {
        console.log("AppSettings", response);
        const MoreThenHour = response.data.filter((item, index) => {
          return item.key.toUpperCase() === "DASHBOARD_VISITOR_IN_MORE_THAN_X_HOURS"
        })

        const GetApiTime = response.data.filter((item, index) => {
          return item.key.toUpperCase() === "PORTAL_DASHBOARD_REFRESH_TIME"
        })
        console.log("GetApiTime", GetApiTime[0]?.value);
        setApiHitTime(GetApiTime[0]?.value)
        setMoreThanHour(MoreThenHour[0]?.value);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = {
        "userId": myUserData?.userId,
        "mobileNumber": myUserData?.mobileNumber,
        "requestJSON": null,
        "uri": "/api/Master/AppSettings",
        "errorNumber": "AS01",
        "errorSource": ErrorSource,
        "errorSummary": error.message,
        "errorDescription": error.message,
        "fileClassName": "Dashboard.js",
        "functionName": "GetAppSetting",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response.success == true && response.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }

  }

  const GetDashboardData = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    try {
      if (!navigator.onLine) {
        setLoading(false);
        return; // Stop further execution when offline
      }
      // setLoading(true);
      const date = new Date();
      const dayBeforeGet = new Date(date.getTime() - 48 * 60 * 60 * 1000);
      const YesterdayGet = new Date(date.getTime() - 24 * 60 * 60 * 1000);
      const dayBeforeYesterday = String(dayBeforeGet.getMonth() + 1).padStart(2, "0") + "/" + String(dayBeforeGet.getDate()).padStart(2, "0") + "/" + dayBeforeGet.getFullYear()
      const Yesterday = String(YesterdayGet.getMonth() + 1).padStart(2, "0") + "/" + String(YesterdayGet.getDate()).padStart(2, "0") + "/" + YesterdayGet.getFullYear()
      const Todaydata = String(date.getMonth() + 1).padStart(2, "0") + "/" + String(date.getDate()).padStart(2, "0") + "/" + date.getFullYear()
      console.log("today dateT", Todaydata, Yesterday, dayBeforeYesterday)
      
      if(SelectDay == "Today"){
        const endPointVariableKey = {
          urlVariable: `?StartDate=${Todaydata}&EndDate=${Todaydata}`,
          // urlVariable: `?StartDate=05/23/2024&EndDate=05/23/2024`,
          buildingId: myUserData?.buildingId

        }
        let response = await commonAPI("DashboardData", undefined, endPointVariableKey)
        if (response?.success == true) {
          console.log("DashboardData Today", response)
          if (response?.data.length == 0) {
            setDashBoardAPIData(0);
            setLoading(false);
          } else {
            setLoading(false);
            setDashBoardAPIData(response?.data[0]);
          }

          setLoading(false);
        } else {
          setLoading(false);
          // toast.error("Something went wrong");
        }
        return
      }else if(SelectDay == "Yesterday")  {
        const endPointVariableKey = {
          urlVariable: `?StartDate=${Yesterday}&EndDate=${Yesterday}`,
          // urlVariable: `?StartDate=05/23/2024&EndDate=05/23/2024`,
          buildingId: myUserData?.buildingId

        }
        let response = await commonAPI("DashboardData", undefined, endPointVariableKey)
        if (response?.success == true) {
          console.log("DashboardData Yesterday", response)
          if (response?.data.length == 0) {
            setDashBoardAPIData(0);
            setLoading(false);
          } else {
            setDashBoardAPIData(response?.data[0]);
            setLoading(false);
          }

        } else {
          setLoading(false);
          // toast.error("Something went wrong");
        }
        return
      }else if(SelectDay == "DayBeforeYesterday"){
        const endPointVariableKey = {
          urlVariable: `?StartDate=${dayBeforeYesterday}&EndDate=${dayBeforeYesterday}`,
          // urlVariable: `?StartDate=05/23/2024&EndDate=05/23/2024`,
          buildingId: myUserData?.buildingId

        }
        let response = await commonAPI("DashboardData", undefined, endPointVariableKey)
        if (response?.success == true) {
          console.log("DashboardData DayBeforeYesterday", response)
          if (response?.data.length == 0) {
            setLoading(false);
            setDashBoardAPIData(0);
          } else {
            setLoading(false);
            setDashBoardAPIData(response?.data[0]);
          }

          
        } else {
          setLoading(false);
          // toast.error("Something went wrong");
        }
        return
      }
      

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = {
        "userId": myUserData?.userId,
        "mobileNumber": myUserData?.mobileNumber,
        "requestJSON": null,
        "uri": "/api/Dashboard/DashboardData",
        "errorNumber": "RU01",
        "errorSource": ErrorSource,
        "errorSummary": error.message,
        "errorDescription": error.message,
        "fileClassName": "Dashboard.js",
        "functionName": "GetDashboardData",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response.success == true && response.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }

  }

  const GetDashboardData7Day = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    try {
      if (!navigator.onLine) {
        setLoading(false);
        return; // Stop further execution when offline
      }
      const date = new Date();
      const last = new Date(date.getTime() - (6 * 24 * 60 * 60 * 1000));
      const day = last.getDate();
      const month = last.getMonth() + 1;
      const year = last.getFullYear();
      const Last7Date = String(last.getMonth() + 1).padStart(2, "0") + "/" + String(last.getDate()).padStart(2, "0") + "/" + last.getFullYear()
      console.log("last 7 day date", day + "" + month + "" + year)



      const Todaydata = String(date.getMonth() + 1).padStart(2, "0") + "/" + String(date.getDate()).padStart(2, "0") + "/" + date.getFullYear()
      console.log("today dateT", Todaydata)
      const endPointVariableKey = {
        urlVariable: `?StartDate=${Last7Date}&EndDate=${Todaydata}`,
        // urlVariable: `?StartDate=05/23/2024&EndDate=05/23/2024`,
        buildingId: myUserData?.buildingId

      }
      let response = await commonAPI("DashboardData", undefined, endPointVariableKey)
      // setLoading(true);
      if (response?.success == true) {
        console.log("DashboardData last 7day", response)
        setDashBoardAPIDataLast(response?.data);
        const consumedCount = response?.data.map((item) => {
          return item?.smsConsumedCount
        })
        const consumedCountDate = response?.data.map((item) => {
          return formatDateString(item?.recordDate)
        })
        const EmailConsumedCount = response?.data.map((item) => {
          return item?.emailConsumedCount
        })
        const NotificationConsumedCount = response?.data.map((item) => {
          return item?.notificationConsumedCount
        })
        console.log("consumedCountDate", consumedCountDate)
        setLoading(false);
        setSmsConsumedCount(consumedCount);
        setSmsConsumedCountDate(consumedCountDate);
        setEmailConsumedCountDate(EmailConsumedCount);
        setNotificationConsumedCountDate(NotificationConsumedCount);
      } else {
        setLoading(false);
        // toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = {
        "userId": myUserData?.userId,
        "mobileNumber": myUserData?.mobileNumber,
        "requestJSON": null,
        "uri": "/api/Dashboard/DashboardData",
        "errorNumber": "RU01",
        "errorSource": ErrorSource,
        "errorSummary": error.message,
        "errorDescription": error.message,
        "fileClassName": "Dashboard.js",
        "functionName": "GetDashboardData7Day",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }

  }

  useEffect(() => {
    if(ApiHitTime){
      const ApiTime = ApiHitTime*1000;
      console.log("apitime", ApiTime)
      const GetDashDataInter = setInterval(GetDashboardData, ApiTime);
      return () => {
        clearInterval(GetDashDataInter); // clear interval when component unmounts
      };

    }
    if (navigator.onLine) {
      GetDashboardData();
    }else{
      return;
    }
  }, [SelectDay, ApiHitTime])

  useEffect(() => { 
    if (navigator.onLine) {    
      GetDashboardData();
    }else{
      return;
    }
  }, [SelectDay])

  useEffect(() => {
    // GetAppSetting();
    // GetDashboardData();
    if(ApiHitTime){
      const ApiTime = ApiHitTime*1000;
      const GetDashData7DayInter = setInterval(GetDashboardData7Day, ApiTime);
      return () => {
        clearInterval(GetDashData7DayInter); // clear interval when component unmounts
      };
    }  
    
    if (navigator.onLine) {
      GetDashboardData7Day();
    }else{
      return;
    }
  }, [ApiHitTime])

  const GetVisitorList = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    
    try {
      if (!navigator.onLine) {
        setLoading(false);
        return; // Stop further execution when offline
      }
        const endPointVariableKey    = {
          urlVariable:null,
          buildingId: myUserData?.buildingId
      
      }
        // setLoading(true);
        let response = await commonAPI("OverstayVisitors", undefined, endPointVariableKey)
        if (response?.success === true){
            console.log("OverstayVisitors", response)
            setVisitorDataList(response?.data);
            setLoading(false);
        }else{
            // toast.error("Something went wrong");
            setLoading(false);
        }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = {
          "userId": myUserData?.userId,
          "mobileNumber": myUserData?.mobileNumber,
          "requestJSON": null,
          "uri": "/api/Dashboard/DashboardData",
          "errorNumber": "VL01",
          "errorSource": ErrorSource,
          "errorSummary": error.message,
          "errorDescription": error.message,
          "fileClassName": "Dashboard.js",
          "functionName": "GetVisitorList",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response.success == true && response.message.length == 0) {
          // toast.error("Something went wrong");
          setLoading(false);
        } else {
          setLoading(false);
          // toast.error("Something went wrong");
        }
    }

  }

  useEffect(() => {
    if(ApiHitTime){
      const ApiTime = ApiHitTime*1000;
      const GetVisitorInter = setInterval(GetVisitorList, ApiTime);
      return () => {
        clearInterval(GetVisitorInter); // clear interval when component unmounts
      };
    }  
    if (navigator.onLine) {
      GetVisitorList();
    }else{
      return;
    }
  }, [ApiHitTime])


 

  const state = {
    labels: ["Visitors", "Resident"],
    datasets: [
      {
        label: "Vehicle In",
        backgroundColor: ["#2295d2", "#2e333f"],
        data: [
          DashBoardAPIData?.visitorCarIn + DashBoardAPIData?.visitorBikeIn,
          DashBoardAPIData?.residentCarIn + DashBoardAPIData?.residentBikeIn,
        ],
      },
    ],
  };

  
  
  
  

  const state10 = {
    labels: ["Visitors", "Residents"],
    datasets: [
      {
        label: "Vehicle In",
        backgroundColor: ["#2295d2", "#2e333f"],
        data: [DashBoardAPIData?.visitorCarOut + DashBoardAPIData?.visitorBikeOut, DashBoardAPIData?.residentCarOut + DashBoardAPIData?.residentBikeOut],
      },
    ],
  };


  const state1 = {
    labels: ["4W", "2W"],
    datasets: [
      {
        label: "Vehicle In",
        backgroundColor: ["#2295d2", "#2e333f"],
        data: [DashBoardAPIData?.residentCarIn + DashBoardAPIData?.visitorCarIn, DashBoardAPIData?.residentBikeIn + DashBoardAPIData?.visitorBikeIn],
      },
    ],
  };


  const state11 = {
    labels: ["4W", "2W"],
    datasets: [
      {
        label: "Vehicle In",
        backgroundColor: ["#2295d2", "#2e333f"],
        data: [DashBoardAPIData?.residentCarOut + DashBoardAPIData?.visitorCarOut, DashBoardAPIData?.residentBikeOut + DashBoardAPIData?.visitorBikeOut],
      },
    ],
  };

  const state4 = {
    labels: SmsConsumedCountDate,
    datasets: [
      {
        label: "SMS QUOTA",
        backgroundColor: [
          "#bd8d00",
          "Purple",
          "Yellow",
          "Teal",
          "Red",
          "Navy",
          "Brown",
        ],
        fill: false,
        lineTension: 0.5,
        borderColor: "#bd8d00",
        borderWidth: 1,

        data: SmsConsumedCount,
      },
    ],
  };

  const state5 = {
    labels: SmsConsumedCountDate,
    datasets: [
      {
        label: "EMAIL QUOTA",
        backgroundColor: [
          "#bd8d00",
          "Purple",
          "Yellow",
          "Teal",
          "Red",
          "Navy",
          "Brown",
        ],
        fill: false,
        lineTension: 0.5,
        borderColor: "#bd8d00",
        borderWidth: 1,
        data: EmailConsumedCountDate,
        // data: [0, 10, 0, 0, 0, 0, 0],
      },
    ],
  };

  const state6 = {
    labels: SmsConsumedCountDate,
    datasets: [
      {
        label: "NOTIFICATION QUOTA",
        backgroundColor: [
          "#bd8d00",
          "Purple",
          "Yellow",
          "Teal",
          "Red",
          "Navy",
          "Brown",
        ],
        fill: false,
        lineTension: 0.5,
        borderColor: "#bd8d00",
        borderWidth: 1,
        data: NotificationConsumedCountDate,
      },
    ],
  };

  const chartRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (chartRef.current && chartRef.current.chartInstance) {
        chartRef.current.chartInstance.resize();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {Loading ?
        <div className="loaderDiv">
          <div className="loader"></div>
        </div>
        : null}
      <Menus />
        <ToastContainer />
      
      
      {UserData?.roleName == "Society Admin" || UserData?.roleName == "Support Admin" || UserData?.roleName == "Super Admin"  || UserData?.roleName == "Society Operator" ?
        <>
            <div className="dashalign">

              <div className="container-fluid mt-5 pt-5">
            
              <div className="buildnm">
              <span> {UserData?.buildingName}</span>
          </div>
              <div className="dashdropindex">
                {/* <DateRangePicker ranges={Ranges} /> */}
                        <select class="b-0 py-1 px-2 bg-white" onChange={(e) => {setSelectDay(e.target.value);}}>   
                                      <option selected="Today">Today</option>
                              <option value="Yesterday"> Yesterday </option>
              
                              <option value="DayBeforeYesterday"> Day Before Yesterday</option>

                        </select>
              </div> 
            
    <div className="row">
      <div className="col-lg-3 col-md-3 col-sm-12 col-12">
          <div className="nextBox">
                <div className='curonextimg1'>
                      <img src={footfall} className="img img-responsive"/>
                </div>

                <div className='curonumb1'>
                <span> Footfall </span> 
                    <h3 className="digits">{!DashBoardAPIData ? "0" : DashBoardAPIData?.walkinVisitor + DashBoardAPIData?.residentCarIn + DashBoardAPIData?.visitorCarIn + DashBoardAPIData?.residentBikeIn + DashBoardAPIData?.visitorBikeIn}  </h3>
                </div>
                <div className="boxfoot">
                  <img src={footfall2} className="img img-responsive"/>
                  <p> Today's Total Footfall in Society </p>
                </div>
            </div>
      </div>
      <div className="col-lg-3 col-md-3 col-sm-12 col-12">
          <div className="nextBox">
                <div className='curonextimg2'>
                      <img src={hiking} className="img img-responsive"/>
                </div>
                <div className='curonumb2'>
                <span> Walk-In </span> 
                    <h3 className="digits"> {!DashBoardAPIData ? "0" : DashBoardAPIData?.walkinVisitor}  </h3>
                </div>
                <div className="boxfoot">
                <img src={hiking2} className="img img-responsive"/>
                  <p> Total Walk-In Visitor Count </p>
                </div>
            </div>
      </div>
      <div className="col-lg-3 col-md-3 col-sm-12 col-12">
          <div className="nextBox">
                <div className='curonextimg3'>
                      <img src={veh} className="img img-responsive"/>
                </div>
                <div className='curonumb3'>
                <span> 4 Wheeler </span> 
                    <h3 className="digits">{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentCarIn + DashBoardAPIData?.visitorCarIn} </h3>
                </div>
                <div className="boxfoot">
                <img src={veh2} className="img img-responsive"/>
                  <p> Total 4 Wheeler Count </p>
                </div>
            </div>
      </div>
      <div className="col-lg-3 col-md-3 col-sm-12 col-12">
          <div className="nextBox">
                <div className='curonextimg4'>
                      <img src={vst} className="img img-responsive"/>
                </div>
                <div className='curonumb4'>
                <span> 2 Wheeler </span> 
                    <h3 className="digits">{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentBikeIn + DashBoardAPIData?.visitorBikeIn}  </h3>
                </div>
                <div className="boxfoot">
                <img src={vst2} className="img img-responsive"/>
                <p> Total 2 Wheeler Count </p>
                </div>
            </div>
      </div>
    </div>

                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row marginBothDiv">
                      <div class="col-lg-3 col-md-12">
                        <div class="card graphbg">
                          <div class="card-body">
                            <div class="text-center m-b-30 no-block ttltext">
                              <h5 class="fw-bold card-title b m-b-0 align-self-center">
                                TRANSIT IN (TOTAL)
                              </h5>
                              {/* <div class="ml-auto">
                                <select class=" b-0 fw-bold">
                                  <option selected="">Today</option>
                                  <option value="1">Tomorrow</option>
                                  <option value="2">Weekly</option>
                                </select>
                              </div> */}
                            </div>
                            <div id="visitor" style={{position: "relative", height: "206px", width: "225px"}}>
                            <Pie
                              ref={chartRef}
                              data={state}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false, // Allow the chart to fill the container
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "top",
                                    labels: {
                                      font: {
                                        size: 10, // Change the size to your preference
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="card">
                          <div class="row pt-3 px-3 justify-content-center">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                              <div class="fnfAct">
                                <div class="heading_subcat">
                                  <h4>VEHICLE IN (TOTAL)</h4>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNumMain">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentCarIn + DashBoardAPIData?.visitorCarIn}</h2>
                                    </div>
                                    <div class="actTextMain">
                                      <h3>4 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNumMain">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentBikeIn + DashBoardAPIData?.visitorBikeIn}</h2>
                                    </div>
                                    <div class="actTextMain">
                                      <h3>2 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row pt-4 mb-3 px-3 mt-3 justify-content-center">
                          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                              <div class="fnfAct">
                                <div class="visitorin">
                                  <h4>VISITOR</h4>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNum">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.visitorCarIn}</h2>
                                    </div>
                                    <div class="actText">
                                      <h3>4 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNum">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.visitorBikeIn}</h2>
                                    </div>
                                    <div class="actText">
                                      <h3>2 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                              <div class="fnfAct">
                                <div class="residentin">
                                  <h4>RESIDENT</h4>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNum">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentCarIn}</h2>
                                    </div>
                                    <div class="actText">
                                      <h3>4 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNum">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentBikeIn}</h2>
                                    </div>
                                    <div class="actText">
                                      <h3>2 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-3 col-sm-12 col-12">
                        <div class="card graphbg">
                          <div class="card-body">
                            <div class="text-center m-b-30 no-block ttltext">
                              <h5 class="fw-bold card-title b m-b-0 align-self-center ">
                                VEHICLE TRANSIT IN (TOTAL)
                              </h5>
    
                            </div>
                            <div id="visitor" style={{position: "relative", height: "206px", width: "225px"}}>
                            {/* <Pie data={state1} options={{ responsive: true, maintainAspectRatio: true, title: { display: true, text: "Class Strength", fontSize: 20, }, legend: { display: true, position: "right", }, plugins: { legend: { labels: { font: { size: 10, // Change the size to your preference }, }, }, }, }} /> */}
                            <Pie
                              ref={chartRef}
                              data={state1}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false, // Allow the chart to fill the container
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "top",
                                    labels: {
                                      font: {
                                        size: 10, // Change the size to your preference
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row marginBothDiv">
                      <div class="col-lg-3 col-md-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="text-center m-b-30 no-block ttltext">
                              <h5 class="fw-bold card-title b m-b-0 align-self-center">
                                TRANSIT OUT (TOTAL)
                              </h5>
    
                            </div>
                            <div id="visitor" style={{position: "relative", height: "206px", width: "225px"}}>
                            <Pie
                              ref={chartRef}
                              data={state10}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false, // Allow the chart to fill the container
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "top",
                                    labels: {
                                      font: {
                                        size: 10, // Change the size to your preference
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="card">
                          <div class="row pt-3 px-3 justify-content-center">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                              <div class="fnfAct">
                                <div class="heading_subcat">
                                  <h4>VEHICLE OUT (TOTAL)</h4>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNumMain">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.visitorCarOut + DashBoardAPIData?.residentCarOut}</h2>
                                    </div>
                                    <div class="actTextMain">
                                      <h3>4 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNumMain">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentBikeOut + DashBoardAPIData?.visitorBikeOut}</h2>
                                    </div>
                                    <div class="actTextMain">
                                      <h3>2 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row pt-4 mb-3 px-3 mt-3 justify-content-center">

                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                              <div class="fnfAct">
                                <div class="visitorin">
                                  <h4> VISITOR</h4>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNum">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.visitorCarOut}</h2>
                                    </div>
                                    <div class="actText">
                                      <h3>4 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNum">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.visitorBikeOut}</h2>
                                    </div>
                                    <div class="actText">
                                      <h3>2 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                              <div class="fnfAct">
                                <div class="residentin">
                                  <h4>RESIDENT</h4>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNum">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentCarOut}</h2>
                                    </div>
                                    <div class="actText">
                                      <h3>4 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="totalIn">
                                  <div class="activityArea">
                                    <div class="actNum">
                                      <h2>{!DashBoardAPIData ? "0" : DashBoardAPIData?.residentBikeOut}</h2>
                                    </div>
                                    <div class="actText">
                                      <h3>2 Wheeler</h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-3 col-sm-12 col-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="text-center m-b-30 no-block ttltext">
                              <h5 class="fw-bold card-title b m-b-0 align-self-center ">
                                VEHICLE TRANSIT OUT (TOTAL)
                              </h5>
    
                            </div>
                            <div id="visitor" style={{position: "relative", height: "206px", width: "225px"}}>
                            <Pie
                              ref={chartRef}
                              data={state11}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "top",
                                    labels: {
                                      font: {
                                        size: 10,
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



                <div className="row marginBothDiv">


    <div className="col-lg-3 col-md-3 col-sm-12 col-12">
    <div className="label_visitor">
              <h4> VISITORS IN {'>'} {MoreThanHour}HRS </h4>
        </div>
    </div>
    <div className="col-lg-3 col-md-3 col-sm-12 col-12">
    <div className="label_visitor">
        
        </div>
    </div>
    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
    <div className="label_visitor">
              <h4> VISITORS LIST {'>'} {MoreThanHour}HRS </h4>
        </div>
    </div>

    <div className="col-lg-3 col-md-3 col-sm-12 col-12">
    <div className="nextBox">
    <div className='curonextimg5'>
    <img src={veh} className="img img-responsive"/>
    </div>
    <div className='curonumb5'>
    <span> 4 Wheeler </span> 
    <h3 className="digits">{!DashBoardAPIData ? "0" : DashBoardAPIData?.visitorCarMoreThanXHours}  </h3>
    </div>
    <div className="boxfoot">
    <img src={smallcar} className="img img-responsive"/>
    <p>   4W Visitor-In  </p>
    </div>
    </div>
    </div>
    <div className="col-lg-3 col-md-3 col-sm-12 col-12">
    <div className="nextBox">
    <div className='curonextimg6'>
    <img src={vst} className="img img-responsive"/>
    </div>
    <div className='curonumb6'>
    <span> 2 Wheeler </span> 
    <h3 className="digits">{!DashBoardAPIData ? "0" : DashBoardAPIData?.visitorBikeMoreThanXHours}  </h3>
    </div>
    <div className="boxfoot">
    <img src={vst2} className="img img-responsive"/>
    <p> 2W Visitor-In </p>
    </div>
    </div>
    </div>

    <div className="col-lg-6 col-md-6 col-sm-12 col-12">







    <div className="listvisitor">





                                        
                                      

                                            <Table ordered hover className="tableFixHeadDash">

                                                <thead > 

                                                            
                                                        <tr>
                                                            <th>Name</th> 
                                                            <th>Phone#</th>
                                                            <th>Tower / Flat# </th>
                                                            <th>Vehicle #</th>  
                                                            <th>Vehicle Type</th>  
                                                            <th>Hours</th>
                                                            <th>Type</th>
                                                        </tr>
                                              
                                                    </thead>
                                                    <tbody>
                                                    {VisitorDataList
                                                      ? VisitorDataList?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="dashtabletext"> {item?.visitorName}</td>
                                                            <td> {item?.mobileNumber}</td>
                                                            <td> {item?.towerName} - {item?.flatName} </td>
                                                            <td> {item?.vehicleNumber} </td> 
                                                            <td> {item?.vehicleType} </td> 
                                                            <td> {item?.inHrs}hrs</td>
                                                            <td> {item?.visitorType} </td>  
                                                        </tr> 
                                                    )):null}   
                                                        {/* <tr>
                                                            <td> Rohit Singh </td>
                                                            <td> 8967547645</td>
                                                            <td> 602 </td>
                                                            <td> 2 Wheeler </td> 
                                                            <td> 6 hrs</td>
                                                            <td> Visitor </td> 
                                                        </tr> 
                                                        <tr>
                                                            <td> Gaurav Jha </td>
                                                            <td> 6798786734</td>
                                                            <td> 603 </td>
                                                            <td> 4 Wheeler </td> 
                                                            <td> 4 hrs</td>
                                                            <td> Visitor </td> 
                                                        </tr> 
                                                        <tr>
                                                            <td> Vaibhav Singh </td>
                                                            <td> 6789902389</td>
                                                            <td> 604 </td>
                                                            <td> 2 Wheeler </td> 
                                                            <td> 3 hrs</td>
                                                            <td> Delivery </td> 
                                                        </tr> 
                                                        <tr>
                                                            <td> Gaurav Singh </td>
                                                            <td> 9667574201</td>
                                                            <td> 601 </td>
                                                            <td> 4 Wheeler </td> 
                                                            <td> 12 hrs</td>
                                                            <td> Guest </td> 
                                                        </tr> 
                                                        <tr>
                                                            <td> Rohit Singh </td>
                                                            <td> 8967547645</td>
                                                            <td> 602 </td>
                                                            <td> 2 Wheeler </td> 
                                                            <td> 8 hrs</td>
                                                            <td> Visitor </td> 
                                                        </tr> 
                                                        <tr>
                                                            <td> Gaurav Jha </td>
                                                            <td> 6798786734</td>
                                                            <td> 603 </td>
                                                            <td> 4 Wheeler </td> 
                                                            <td> 6 hrs</td>
                                                            <td> Visitor </td> 
                                                        </tr> 
                                                        <tr>
                                                            <td> Vaibhav Singh </td>
                                                            <td> 6789902389</td>
                                                            <td> 604 </td>
                                                            <td> 2 Wheeler </td> 
                                                            <td> 10 hrs</td>
                                                            <td> Delivery </td> 
                                                        </tr>  */}
                                                    </tbody> 
                                                  
                                            </Table>    
                                    
                                        
                            
                                        </div>






                                    
    </div>

    </div>

    <div className="row marginBothDiv ">
                <div className="col-lg-3 col-md-3 col-sm-12 col-12">
          <div className="datauseage">
                  <h4> DATA CONSUMPTION </h4>
            </div>
        </div>
        </div>
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="d-flex m-b-30 no-block">
                          <h5 className="fw-bold card-title b m-b-0 align-self-center">
                            SMS{" "}
                          </h5>
                          {/* <div className="ml-auto">
                            <select className="custom-select b-0 fw-bold">
                              <option>Today</option>
                              <option value="1">Tomorrow</option>
                              <option value="2">Weekly</option>
                            </select>
                          </div> */}
                        </div>

                        <div className="d-flex justify-content-between">
                          <div className="SMS">
                            <h4>TOTAL </h4>
                            <span>{DashBoardAPIData?.smsBalance}</span>
                          </div>
                          <div className="SMS">
                            <h4> USED</h4>
                            <span> {DashBoardAPIData?.smsConsumedCount} </span>
                          </div>
                          <div className="SMS">
                            <h4> BALANCE</h4>
                            <span>{DashBoardAPIData ? DashBoardAPIData?.smsBalance - DashBoardAPIData?.smsConsumedCount : ""}</span>
                          </div>
                        </div>

                        <div className="pt-3" id="visitor">
                          <Line
                            data={state4}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              title: {
                                display: true,
                                text: "Class Strength",
                                fontSize: 20,
                              },
                              legend: {
                                display: true,
                                position: "right",
                              },
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="d-flex m-b-30 no-block">
                          <h5 className="fw-bold card-title b m-b-0 align-self-center">
                            EMAIL {" "}
                          </h5>
                          {/* <div className="ml-auto">
                            <select className="custom-select b-0 fw-bold">
                              <option>Today</option>
                              <option value="1">Tomorrow</option>
                              <option value="2">Weekly</option>
                            </select>
                          </div> */}
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="SMS">
                            <h4>TOTAL </h4>
                            <span>{DashBoardAPIData?.emailBalance}</span>
                          </div>
                          <div className="SMS">
                            <h4> USED</h4>
                            <span>{DashBoardAPIData?.emailConsumedCount}</span>
                          </div>
                          <div className="SMS">
                            <h4> BALANCE</h4>
                            <span>{DashBoardAPIData ? DashBoardAPIData?.emailBalance - DashBoardAPIData?.emailConsumedCount : ""} </span>
                          </div>
                        </div>

                        <div className="pt-3" id="visitor">
                          <Line
                            data={state5}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              title: {
                                display: true,
                                text: "Class Strength",
                                fontSize: 20,
                              },
                              legend: {
                                display: true,
                                position: "right",
                              },
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="d-flex m-b-30 no-block">
                          <h5 className="fw-bold card-title b m-b-0 align-self-center">
                            NOTIFICATION{" "}
                          </h5>
                          {/* <div className="ml-auto">
                            <select className="custom-select b-0 fw-bold">
                              <option>Today</option>
                              <option value="1">Tomorrow</option>
                              <option value="2">Weekly</option>
                            </select>
                          </div> */}
                        </div>

                        <div className="d-flex justify-content-between">
                          <div className="SMS">
                            <h4>TOTAL </h4>
                            <span>{DashBoardAPIData?.notificationBalance} </span>
                          </div>
                          <div className="SMS">
                            <h4> USED</h4>
                            <span> {DashBoardAPIData?.notificationConsumedCount} </span>
                          </div>
                          <div className="SMS">
                            <h4> BALANCE</h4>
                            <span> {DashBoardAPIData ? DashBoardAPIData?.notificationBalance - DashBoardAPIData?.notificationConsumedCount : ""} </span>
                          </div>
                        </div>

                        <div className="pt-3" id="visitor">
                          <Line
                            data={state6}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              title: {
                                display: true,
                                text: "Class Strength",
                                fontSize: 20,
                              },
                              legend: {
                                display: true,
                                position: "right",
                              },
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          
        </>  
        :null
      }
      {showAccess && <div className='bg-white ' style={{ height: "400px", borderRadius: "10px", marginTop: "100px", margin: "100px" }}>
          <div className='col-12 text-center'>
            <img src={noAccess} alt="user" className="mx-auto mt-5" style={{ height: "150px" }} />
          </div>
          <br />
          <h3 className='col-12 text-center' style={{ marginTop: "0px" }}> You don't have any access</h3>
          <h5 className='col-12 text-center' style={{ marginTop: "10px" }}> Please contact Admin </h5>
        </div>
      }
    </>
  );
}
export default Dashboard;
